export default {
  title: 'Muuta saatavuutta',
  amend_availabilities_form: {
    date: {
      label: 'Valitse päivämäärä',
    },
    times: {
      label: 'Vuorot ja aukioloajat',
      description:
        'Määritä aukioloajat valitulle päivälle. Pidennä, lyhennä tai sulje vuoroja. Vähintään yhden vuoron on oltava auki.',
      breakfast: {
        label: 'Aamiainen',
      },
      lunch: {
        label: 'Lounas',
      },
      dinner: {
        label: 'Illallinen',
      },
    },
  },
  reason: {
    label: 'Lisää syy (valinnainen)',
    placeholder: 'Kirjoita kuvaus...',
  },
  buttons: {
    save: 'Tallenna',
  },
  projects: {
    online_shop: 'Verkkokauppa',
    reservations: 'Varaukset',
    storefront: 'Storefront',
  },
  error_messages: {
    creation_failed: 'Poikkeuksen luominen epäonnistui',
  },
};
